import * as Yup from 'yup';
import { normalizePhone } from './textFormatters';
const alphabetandSpacesOnly = /^[a-z\s]+$/i;
const phonefmt = require('google-libphonenumber').PhoneNumberUtil.getInstance();

// const mobileValidation = Yup.string()
//   .required("Phone number is required.")
//   .test("validity", "Kindly provide a valid phone number.", val => {
//     if (val !== undefined) {
//       const regex = new RegExp(/^0?[789][01][0-9]{8}$/);
//       return val.match(regex);
//     }
//   });
const mobileValidation = Yup.string()
  .test('phone', null, function(value) {
    const { path, parent, createError } = this;
    const phoneNumber = normalizePhone(parent.dialCode, value);
    if (value) {
      try {
        if (!isPhone(phoneNumber)) {
          return createError({ path, message: 'Enter valid phone number' });
        }
      } catch (e) {
        // console.log(e.message);
        return createError({ message: 'Enter valid phone number' });
      }
    }
  })
  .required('* Phone Number is required');

const emailValidation = Yup.string()
  .trim()
  .required()
  .email('Please enter a valid email.');

export const checkoutCartSchema = Yup.object().shape({
  customerName: Yup.string()
    .required('Full name is required')
    .matches(alphabetandSpacesOnly, 'No special characters '),
  // customerEmail: emailValidation,
  customerEmail: Yup.string().email('Invalid email').required('Email is required'),
  phone: mobileValidation,
  deliveryMethod: Yup.string(),
  deliveryLocation: Yup.string().when("deliveryMethod", {
    is: deliveryMethod => deliveryMethod === 'delivery',
    then: () => Yup.string(),
    otherwise: () => Yup.string()
  }),
  customerAddress: Yup.string().when('deliveryMethod', {
    is: deliveryMethod => deliveryMethod === 'delivery',
    then: () => Yup.string(),
    otherwise: () => Yup.string()
  })
});

export function isPhone(phone) {
  // console.log(phonefmt.isValidNumber(phonefmt.parse(phone)));
  return phonefmt.isValidNumber(phonefmt.parse(phone));
}
